export function getHost () {
  if (process.env.NODE_ENV === 'development') {
    return 'dev.test.teliawholesale.se'
  }

  return window.location.host
}
